import { has, isEmpty, map } from 'lodash';

import { isTableType } from 'constants/chart-roles';

const applyWidthToColumn = (column, columnWidths) => {
  if (columnWidths[column.field] === undefined) {
    return column;
  }

  return { ...column, width: columnWidths[column.field] };
};

function resizeTableColumns(stageData) {
  const {
    environment: { chartType },
    spec: { columnDefs, meta },
  } = stageData;

  if (!isTableType(chartType)) {
    return {};
  }

  if (isEmpty(meta.columnWidths)) {
    return {};
  }

  const modifiedColumnDefs = map(columnDefs, column => {
    if (has(column, 'children')) {
      return {
        ...column,
        children: map(column.children, child =>
          applyWidthToColumn(child, meta.columnWidths)
        ),
      };
    }

    return applyWidthToColumn(column, meta.columnWidths);
  });

  return {
    spec: {
      ...stageData.spec,
      columnDefs: modifiedColumnDefs,
    },
  };
}

export default {
  input: ['environment.chartType', 'spec'],
  fn: resizeTableColumns,
};
